import React from "react";
import { FaInfoCircle, FaExclamationTriangle } from "react-icons/fa";

const alerts = [
  {
    id: 1,
    title: "Large Transaction requires approval",
    description: "Transaction #TX452465 exceeds 100 VTSG threshold",
    icon: <FaInfoCircle className="text-[#FF0000] text-xl" />,
    bg: "bg-[#FFDCDC]",
    border: "border-red-300  border-l-2.5 border-l-[#FF0000]",
    button: "Review"
  },
  {
    id: 2,
    title: "Gold reserve verification due",
    description: "Monthly verification required by April 30, 2025",
    icon: <FaExclamationTriangle className="text-[#E6B700] text-xl" />,
    bg: "bg-[#FFF8DC]",
    border: "border-yellow-200  border-l-2.5 border-l-[#E6B700]",
    button: "Schedule"
  },
  {
    id: 3,
    title: "System maintenance scheduled",
    description: "April 20, 2025 from 2:00 AM to 4:00 AM UTC",
    icon: <FaInfoCircle className="text-[#003265] text-xl" />,
    bg: "bg-[#E6F2FE]",
    border: "border-blue-200 border-l-2.5 border-l-[#003265]",
    button: "Details"
  }
];

const SystemAlerts = () => {
  return (
    <div className=" font-poppins w-full mx-auto mb-10">
      <h2 className="text-xl font-bold mb-4">System Alerts</h2>
      <div className="space-y-6">
        {alerts.map((alert) => (
          <div
            key={alert.id}
            className={`flex items-center justify-between p-4 mt-6 border-l-4 rounded-lg  ${alert.bg} ${alert.border}`}
          >
            <div className="flex items-center gap-3">
              <div className="">{alert.icon}</div>
              <div>
                <p className="font-poppins font-medium text-16 leading-4 mb-2">
                  {alert.title}
                </p>
                <p className="font-poppins font-normal text-14 leading-3">
                  {alert.description}
                </p>
              </div>
            </div>
            <button className="border border-gray-300  font-poppins font-medium text-12 leading-4 text-[#7D7D7D] px-4 py-1 rounded-md bg-white hover:bg-gray-50">
              {alert.button}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SystemAlerts;
